// @ts-nocheck
import { observer } from 'mobx-react';

import userStore from 'store/User';
import appStore from 'store/App';
import { Title2, Text1 } from 'pages/Connection/components/Typography';
import { about } from 'pages/Connection/components/AboutCompany';
import InfoScreen from 'pages/Connection/components/InfoScreen';
import InfoDrawer from 'pages/Connection/components/InfoDrawer';
import { getOnboardingStatus } from 'utils/userStatus';

import s from './styles.module.scss';

const Connection = () => {
  const { isAllCompleted } = getOnboardingStatus();

  // Проверяем что данные пользователя загружены
  if (!userStore.me || !userStore.me.company) {
    return <div>Loading...</div>;
  }

  function renderHeader() {
    if (userStore.me.company.status === 'rejected') {
      return (
        <span>
          We regret to inform you that{' '}
          <span style={{ color: '#EC3E72' }}>verification has failed</span>
        </span>
      );
    }

    return isAllCompleted ? (
      <span>
        Thanks for your efforts!
        <br /> Your data{' '}
        <span style={{ color: '#26B634' }}>
          has been successfully
          <br /> collected
        </span>
      </span>
    ) : (
      <div style={{ paddingTop: '20px' }}>
        Please provide information about your company
      </div>
    );
  }

  function renderMain() {
    if (userStore.me.company.status === 'rejected') {
      return <span>Unfortunately, we will not be able to cooperate</span>;
    }

    return isAllCompleted
      ? `Please allow us 48 hours to verify the 
    information provided. Once it has been verified, you can proceed with 
    your funding request.`
      : `To process your advance payment, we need to gather information about your company's financial health and assess your risk score. Rest assured, your data will remain confidential.`;
  }

  function renderMail() {
    if (userStore.me.company.status === 'rejected') {
      return <></>;
    }

    return !isAllCompleted ? (
      <Text1>
        Experiencing any issues? <br />
        Please contact us at{' '}
        <a href="mailto:support@gamesboost42.com">support@gamesboost42.com.</a>
      </Text1>
    ) : (
      ''
    );
  }

  return (
    <>
      {userStore.me.company.status === 'rejected' ? (
        <div className={s.containerNoDrawer}>
          <div className={s.blockNoDrawer}>
            <Title2 className={s.mainTitle}>{renderHeader()}</Title2>
            <Text1 className={s.mainTitle}>{renderMain()}</Text1>
            {renderMail()}
          </div>
        </div>
      ) : (
        <div className={s.container}>
          <div className={s.block}>
            <Title2 className={s.mainTitle}>{renderHeader()}</Title2>
            <Text1 className={s.mainTitle}>{renderMain()}</Text1>
            {renderMail()}
          </div>
          <InfoScreen />
        </div>
      )}

      {appStore.showAccountsDrawer && <InfoDrawer />}
    </>
  );
};

export default observer(Connection);
export { InfoDrawer };
